import {
  CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from "@mui/material/styles";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";
import "@fontsource/inter";
import { theme, theme2 } from "./theme";
import { Navigate, Route, Routes } from "react-router-dom";
import { Principal } from "./pages/Principal";
import { Nav } from "./navigation/Nav";
import { Detalle } from "./pages/Detalle";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Carrito } from "./pages/Carrito";
import { Productos } from "./pages/Productos";
import { Nosotros } from "./pages/Nosotros";
import { Resultado } from "./pages/Resultado";
import Swal from "sweetalert2";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Cursos } from "./pages/Cursos";
import { CursoDetalle } from "./pages/CursoDetalle";
import { Terminos } from "./pages/Terminos";
import { Reembolso } from "./pages/Reembolso";
import { Privacidad } from "./pages/Privacidad";
import { Resultado2 } from "./pages/Resultado2";

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    cargarCarro();
  }, []);

  async function cargarCarro() {
    let car = localStorage.getItem("carritoPublimed");

    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `https://portal.publimed.net/api/v1/CEspecialidad?searchParams={
      "select": ["id", "name", "imagen"]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        let lista = res?.list ?? [];
        let espe = {};
        for (const el of lista) {
          espe[el.name] = el.imagen
            ? "https://" + el.imagen
            : "https://publimed.net/iconos/new/no.png";
        }
        dispatch({
          type: "ESPE_SUCCESS",
          payload: {
            espeImagenes: espe,
            especialidades: [
              ...lista.map((val) => {
                return val.name;
              }),
            ].sort((a, b) => a.localeCompare(b)),
          },
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({
          type: "ESPE_FAIL",
          payload: {
            especialidades: [],
            espeImagenes: {},
          },
        });
      });

    let carro = car ? JSON.parse(car) : [];

    let cursos = carro?.filter((val )=> val?.eleccion === undefined && !(val?.espe?.length  >= 0))
    let articulos = carro?.filter((val )=> val?.eleccion  >= 0)
    let planes = carro?.filter((val )=> val?.espe?.length  >= 0)

    let respuesta = [];

    await fetch(
      `https://portal.publimed.net/api/v1/CPlanArticulo?searchParams={
     "select": ["id","name","deleted","description","precio", "articulos"],
      "where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"},` +
        `{ "type": "in", "attribute": "id","value":` +
        ` [${
          planes
            ?.map((val) => {
              return '"' + val?.producto?.id + '"';
            })
            ?.toString() ?? ""
        }]}]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        let lista = res.list;
        for (const val of planes) {
          let prod = lista.filter((val2) => val2?.id === val?.producto?.id)[0];
          if (prod) {
            let precio = parseFloat(prod?.precio).toFixed(2);
            respuesta.push({
              ...val,
              producto: prod,
              precioFinal: precio,
              total: parseFloat(precio).toFixed(2),
            });
          } else {
            Swal.fire({
              icon: "info",
              text:
                "El plan de reserva: " +
                val?.producto?.name +
                " no esta disponible, se retiró del carrito",
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });


    await fetch(
      `https://portal.publimed.net/api/v1/CCurso?searchParams={
      "select": ["id","name","deleted","description","precio","descuento","preciodescuento","codigoCurso","fotoId","fotoName"],
      "where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"},` +
        `{ "type": "in", "attribute": "id","value":` +
        ` [${
          cursos
            ?.map((val) => {
              return '"' + val?.producto?.id + '"';
            })
            ?.toString() ?? ""
        }]}]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        let lista = res.list;
        for (const val of cursos) {
          let prod = lista.filter((val2) => val2?.id === val?.producto?.id)[0];
          if (prod) {
            let precio = parseFloat(prod?.precio).toFixed(2);
            respuesta.push({
              ...val,
              producto: prod,
              precioFinal: precio,
              total: parseFloat(precio).toFixed(2),
            });
          } else {
            Swal.fire({
              icon: "info",
              text:
                "El curso: " +
                val?.producto?.name +
                " no esta disponible, se retiró del carrito",
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });

    fetch(
      `https://portal.publimed.net/api/v1/CProducto?searchParams={
      "select": ["posicion1Id","posicion2Id","posicion3Id","posicion4Id","posicion5Id",
      "especialidadsIds","id","name","deleted","description","createdAt","modifiedAt","estado","precio","tipo","solicitar","tipo1","tipo2","precio1","precio2","especialidades","descuento","precioSinDescuento","categorias","codigoCurso","precioCurrency","precio1Currency","precio2Currency","precioSinDescuentoCurrency","createdById","createdByName","modifiedById","modifiedByName","assignedUserId","assignedUserName","fotoId","fotoName","precioConverted","precio1Converted","precio2Converted","precioSinDescuentoConverted"],
      "where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"},` +
        `{ "type": "in", "attribute": "id","value":` +
        ` [${
          articulos
            ?.map((val) => {
              return '"' + val?.producto?.id + '"';
            })
            ?.toString() ?? ""
        }]}]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        let lista = res?.list ?? [];

        for (const val of articulos) {
          let prod = lista.filter((val2) => val2?.id === val?.producto?.id)[0];
          if (prod) {
            let precio = !isNaN(val?.eleccion)
              ? [prod?.precio1, prod?.precio2][val?.eleccion]
              : prod?.precio;

            precio = parseFloat(precio).toFixed(2);
            respuesta.push({
              ...val,
              producto: prod,
              precioFinal: precio,
              total: parseFloat(precio).toFixed(2),
            });
          } else {
            Swal.fire({
              icon: "info",
              text:
                "El producto: " +
                val?.producto?.name +
                " no esta disponible, se retiró del carrito",
            });
          }
        }
        localStorage.setItem("carritoPublimed", JSON.stringify(respuesta));
        dispatch({
          type: "CARRO_SUCCESS",
          payload: {
            carro: respuesta,
          },
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({
          type: "CARRO_SUCCESS",
          payload: {
            carro: [],
          },
        });
        localStorage.setItem("carritoPublimed", JSON.stringify([]));
      });
  }

  return (
    <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: theme2 }}>
      <JoyCssVarsProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <Nav>
          <Routes>
            <Route path="/" element={<Principal />} />
            <Route path="/carrito" element={<Carrito />} />
            <Route path="/publicaciones" element={<Productos />} />
            <Route path="/cursos" element={<Cursos />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/articulo/:id" element={<Detalle />} />
            <Route path="/curso/:id" element={<CursoDetalle />} />

            <Route path="/terms-conditions" element={<Terminos />} />
            <Route path="/refund-policy" element={<Reembolso />} />
            <Route path="/privacy-policy" element={<Privacidad />} />

            {/* <Route path="/pago/:id" element={<Pagos />} /> */}

            <Route path="/resultado/:id" element={<Resultado />} />
            <Route path="/response/:id" element={<Resultado2 />} />

            {/* <Route element={<PrivateRoute isAuth={userInfo?.email} />}>
              <Route path="/oportunidades" element={<Oportunidades />} />
            </Route> */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Nav>
      </JoyCssVarsProvider>
    </MaterialCssVarsProvider>
  );
}
